import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Generic reader for `site_settings` (key/value JSON store).
 * Returns the parsed value or null when no row exists.
 */
export function useSiteSettings<T = unknown>(key: string) {
  return useQuery({
    queryKey: ["site_settings", key],
    queryFn: async (): Promise<T | null> => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", key)
        .maybeSingle();
      if (error) return null;
      return (data?.value as T) ?? null;
    },
    staleTime: 60_000,
  });
}
